import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import keycloak, { reAuth } from "../Keycloak";

// @ts-ignore
const baseURL = window.env.baseURL

const baseQuery = fetchBaseQuery({
    baseUrl: baseURL,
    credentials: 'include',
    prepareHeaders: async (headers,) => {
        const token = keycloak.token;
        if(token) {
            headers.set('Authorization', `Bearer ${token}`)
        }
        headers.set('Cache-Control', 'no-cache');
        return headers;
    }
});

const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
    const ok = await reAuth(); // Wait for token refresh
    if (!ok) {
        // User redirected to login
        return {
            error: {
                status: 401,
                data: { message: 'Unauthorized — please log in again' },
            },
        };
    }

    return await baseQuery(args, api, extraOptions)
}

export const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    keepUnusedDataFor: 30,
    tagTypes: ['Auth', 'Database', 'Databases', 'DataWrangler', 'DW_Dashboard', 'All_Users', 'Issues', 'Dashboard', 'Submissions', 'DataDictionary', 'Files', 'DUCInfo', "Data_Providers", "Publications", "ArticulateCourses", "DownloadClient"],
    endpoints: () => ({})
});
